// Generic hook to provide marker label and threshold logic for a slider
export function useSliderMarkers({
  markerLabels,
  min,
  max,
}: {
  markerLabels: string[];
  min: number;
  max: number;
}) {
  const markerCount = markerLabels.length;
  const step = (max - min) / (markerCount - 1);
  const thresholds = Array.from({ length: markerCount }, (_, i) => Math.round(min + i * step));
  return { markerLabels, thresholds, markerCount };
}
